<template>
  <!-- https://stackoverflow.com/questions/61444870/maximum-call-stack-size-exceeded-vuetify -->
  <v-dialog v-model="dialog" max-width="300" :retain-focus="false">
    <v-card class="navy pa-4">
      <div class="navy white--text d-flex align-center font-hemi-head">
        <span style="font-size: 16px">Scegli calciatore da inserire nello slot selezionato</span>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <asta-rosa
        class="pt-4"
        :id_squadra="id_squadra"
        hideCalciatoriImages
        hideEditRemove
        ripple
        :onCalciatoreClick="associa"
        :ruolo_id="ruolo_id"
        :escludi_ids="associati"
      ></asta-rosa>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import AstaRosa from "../common/AstaRosa";
import Vuex from "vuex";
import db from "../../js/db";

export default {
  name: "dialog-associa-calciatore",
  mixins: [mixins],
  components: { AstaRosa },
  mounted() {
    console.log("--> DialogAssociaCalciatore mounted.");
    db.on("DialogAssociaCalciatore", this.show);
  },
  destroyed() {
    console.log("<-- DialogAssociaCalciatore destroyed.");
    db.off("DialogAssociaCalciatore", this.show);
  },
  data() {
    return {
      ruolo_abc: Object.keys(Constants.RUOLO)[0],
      i: null,
      dialog: false,
      processing: false,
    };
  },
  props: {
  },
  methods: {
    show(ruolo_abc, i) {
      this.dialog = true;
      this.error = "";
      this.ruolo_abc = ruolo_abc;
      this.i = i;
    },
    dismiss() {
      this.dialog = false;
    },
    associa(calciatore_id) {
      if (this.processing) {
        return;
      }
      this.processing = true;

      db.setPlanAssociato(this.ruolo_abc, this.i, calciatore_id)
        .then(() => {
          this.dismiss();
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
  computed: {
    id_squadra() {
      return this.my_squadra.id;
    },
    ruolo_id() {
      return Constants.RUOLO[this.ruolo_abc].toString();
    },
    ...Vuex.mapGetters(["associati"]),
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
</style>
